import React, { Component } from "react";
import classNames from "classnames";
import Odometer from "react-odometerjs";
import VisibilitySensor from "react-visibility-sensor";
import "./Statsbar.css";
import "odometer/themes/odometer-theme-default.css";

const StatsbarHOC = (props) => (
  <span>
    <Odometer
      animation={props.animation}
      duration={props.duration}
      format={props.format}
      theme={props.theme}
      value={props.value}
      text={props.text}
      boldText={props.boldText}
      class={props.class}
      units={props.units}
      slash={props.slash}
    />
  </span>
);

class Statsbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      odometerValue: 0,
      didViewCountUp: false,
    };
  }

  componentDidMount() {
    this.setState((props) => ({
      odometerValue: this.props.value,
    }));
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ didViewCountUp: true });
    }
  };

  render() {
    const { odometerValue } = this.state;

    const odometerClassname = classNames({
      "odometer-theme-default statNumberStyle": true,
    });

    return (
      <>
        <VisibilitySensor
          onChange={this.onVisibilityChange}
          offset={{
            top: 10,
          }}
          delayedCall
        >
          <StatsbarHOC
            format={this.props.format}
            duration={this.props.duration}
            value={this.state.didViewCountUp ? odometerValue : 0}
            animation={this.props.animation}
            theme={this.props.theme}
            odometerStyle={odometerClassname}
          />
        </VisibilitySensor>
      </>
    );
  }
}

export default Statsbar;
